module.exports = __webpack_public_path__ + "img/金属材料学5_1.e74ee691.png";